import React from 'react';
import { HelmetProvider as HeadProvider } from 'react-helmet-async';
var VeniaHeadProvider = props => {
  return /*#__PURE__*/React.createElement(HeadProvider, null, props.children);
};
export default VeniaHeadProvider;